
import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import Delivery from "@/components/Delivery/DeliveryView.vue";
import { get_delivery_address_payload } from "@/components/Delivery/delivery_helpers";
import { buy_now_order, delete_cart_item, parse_checkout_slug } from "@/components/cart/cart_helper";
import Swal from "sweetalert2";

export default {
    components: {
        HomeNavBar,
        Delivery
    },

    data() {
        const checkout_params = parse_checkout_slug(this.$route.params.checkout_slug);

        return ({
            token_exists: false,
            orders: [],
            user_details: null,
            delivery_amount: 0,
            payfast: process.env.VUE_APP_PAYFAST_URL,
            loading: false,
            cart: [],
            cart_id: checkout_params.cart || this.$route.query.cart,
            order_id: checkout_params.order || this.$route.query.order,
            cart_item: checkout_params.cart_item || this.$route.query.cart_item,
            buy_now_checkout: checkout_params.buy_now === true || this.$route.query.buy_now === '1',
            checkout_confirmed: false,
            cleaning_buy_now_item: false,
            order_exists: false,
            confirming_order: false,
            cart_items: [],
            payment_types: [],
            delivery_methods: [],
            selected_payment_type: null,
            delivery_method: 'pickup',
            delivery_address: {
                address_id: null,
                contact_name: '',
                email: '',
                contact_phone: '',
                street_address: '',
                suburb: '',
                city: '',
                province: '',
                postal_code: '',
            },
            delivery_address_errors: {},
            default_delivery_amount: 90,
            product_promo_input: "",
            product_promo_message: "",
            product_promo_status: "",
            is_applying_product_promo: false,
            applied_product_promo: null,
            original_order_total_amount: null,
        });
    },
    mounted() {
        this.token_exists = get_token();
        this.user_details = get_user_details();

        if (this.order_id) {
            this.fetch_cart_order();
        } else if (this.cart_item) {
            this.fetch_cart_item();
        } else if (this.cart_id) {
            this.fetch_cart_details();
        }

        this.fetch_payment_types();
        this.fetch_delivery_methods();

    },
    beforeUnmount() {
        this.cleanup_abandoned_buy_now_item();
    },
    computed: {
        total_with_delivery() {
            const subtotal = Number(this.order_total_after_promos || 0);
            return subtotal + this.fulfillment_delivery_amount;
        },
        fulfillment_delivery_amount() {
            if (this.delivery_method === "pickup") {
                return 0;
            }

            if (this.delivery_method !== "delivery") return 0;

            return Number(this.delivery_amount) || this.default_delivery_amount;
        },
       

  order_total_after_promos() {
    const saved_discounted_total = this.get_saved_discounted_total();

    if (saved_discounted_total !== null) return saved_discounted_total;

    return this.get_order_original_total();
  },

  order_discount_amount() {
    const originalTotal = Number(this.orders?.total_amount || 0);
    const discountedTotal = Number(this.order_total_after_promos || 0);

    return Math.max(originalTotal - discountedTotal, 0);
  },

  payment_promo_discount_amount() {
    return this.get_payment_promo_discount_amount();
  },

  cart_total() {
    if (!this.cart_items || !this.cart_items.length) return 0;

    return this.cart_items.reduce((sum, item) => {
      return sum + Number((item.product.final_price ?? item.product.price) || 0) * Number(item.quantity || 0);
    }, 0);
  },

  delivery_method_cards() {
    return this.delivery_methods.map((method) => {
        const value = method.value;
        let price_label = "Rate";

            if (value === "pickup") {
                price_label = this.format_currency(0);
            }

            if (value === "delivery") {
                price_label = this.delivery_method === "delivery"
                    ? this.format_currency(this.fulfillment_delivery_amount)
                    : this.format_currency(this.default_delivery_amount);
            }

        return {
            ...method,
            active: this.delivery_method === value,
            price_label,
        };
    });
  }
},

    methods: {
        go_back() {
            this.$router.back();
        },
        getToken() {
            return get_token();
        },
        get_order_original_total() {
            const original_total = this.original_order_total_amount ?? this.orders?.total_amount;

            return Number(original_total || 0);
        },
        get_saved_discounted_total() {
            const saved_total = this.orders?.total_after_discount ?? this.orders?.discounted_total;

            return saved_total === undefined || saved_total === null || saved_total === "" ? null : Number(saved_total);
        },
        get_order_discount_value() {
            const discount_sources = [
                this.orders?.order_promos?.[0]?.total_discount_amount,
                this.orders?.discount_amount,
            ];
            const discount_value = discount_sources.find((amount) => Number(amount || 0) > 0);
            return Number(discount_value || 0);
        },
        get_payment_promo_discount_amount(promo = this.applied_product_promo) {
            const discount_amount = promo?.discount_amount;
            return Number(discount_amount || 0);
        },
        format_attribute_text(value) {
            return String(value || "")
                .trim()
                .split(/[\s_-]+/)
                .filter(Boolean)
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join(" ");
        },

        format_date_time(datetime) {
            return new Date(datetime).toLocaleString();
        },
        fetch_payment_types() {

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_payment_types/`,
                method: "GET",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                success: (response) => {
                    this.payment_types = Array.isArray(response?.data) ? response.data : [];
                    if (!this.selected_payment_type && this.payment_types.length) {
                        this.selected_payment_type = this.get_payment_type_value(this.payment_types[0]);
                    }
                },
                error: (xhr) => {

                    console.error("Failed to fetch payment types:", xhr.responseText);
                    this.payment_types = [];
                }
            });
        },

        fetch_delivery_methods() {
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_delivery_methods/`,
            method: "GET",
            headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json"
            },
            success: (response) => {
            this.delivery_methods = (response.data || []).map((method) =>
                this.normalize_delivery_method(method)
            );
            },
            error: (xhr) => {
            console.error("Failed to fetch delivery methods:", xhr.responseText);
            this.delivery_methods = [];
            }
        });
        },

        normalize_delivery_method(method) {
            const value = method.name.toLowerCase();
            return ({
                ...method,
                value,
                label: this.format_attribute_text(value),
                icon: value === "pickup"
                ? "bi bi-geo-alt"
                : "bi bi-truck",
            });
        },

        get_payment_type_value(paymentType) {
            return paymentType?.id || paymentType?.name || null;
        },
        is_payment_type_selected(paymentType) {

            return this.selected_payment_type === this.get_payment_type_value(paymentType);

        },

        select_payment_type(paymentType) {

            this.selected_payment_type = this.get_payment_type_value(paymentType);

        },

        format_currency(amount) {
            const value = Number(amount || 0);
            return `R${value.toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`;
        },
  
        get_attribute_label(attribute) {
            return attribute?.attribute_type;
        },
        get_attribute_value(attribute) {
            return attribute?.label || attribute?.value;
        },

        get_item_attributes(item) {
            const attributes =
                item?.attributes || [];

            return attributes
                .map((attribute) => {
                    const rawLabel = this.get_attribute_label(attribute);
                    const rawValue = this.get_attribute_value(attribute);
                    const label = this.format_attribute_text(rawLabel);
                    const value = this.format_attribute_text(rawValue);
                    return { label, value };
                })
                .filter(Boolean);
        },

        fetch_cart_details() {
            const cart_id = this.cart_id;
            const user_id = this.user_details.user_id;
            this.loading = true;


            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart_for_checkout/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify({
                    user_id: user_id,
                    cart_id: cart_id
                }),
                success: (response) => {
                    this.cart = response.cart;
                    this.order_exists = response.order_exists;
                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;
                    console.error("Failed to fetch order:", xhr.responseText);
                },
            });
        },
        confirm_order() {
    Swal.fire({
        title: 'Confirm Order',
        text: 'Your order will be approved first before processing payment.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm order',
        cancelButtonText: 'Cancel',
        position: 'bottom-end',
        toast: true
    }).then((result) => {
        if (result.isConfirmed) {
            this.confirming_order = true;

            const payload = this.get_checkout_confirmation_payload();

            if (!payload) {
                this.confirming_order = false;
                this.show_checkout_error('Checkout item not found.');
                return;
            }

            if (this.delivery_method === 'delivery') {
                if (!this.validate_delivery_address()) {
                    this.confirming_order = false;
                    return;
                }

                payload.delivery_amount = Number(this.fulfillment_delivery_amount || 0).toFixed(2);

                this.save_delivery_address_if_needed()
                    .then((delivery_address) => {
                        payload.delivery_address = delivery_address;
                        payload.address_id = delivery_address.address_id;
                        payload.delivery_address_id = delivery_address.address_id;
                        this.submit_confirmation_payload(payload);
                    })
                    .catch((error) => {
                        this.confirming_order = false;
                        Swal.fire({
                            icon: 'error',
                            title: 'Could not save address',
                            text: error.message || 'Please try again.',
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                    });
                return;
            }

            if (this.delivery_method === 'pickup') {
                payload.pickup_type = "seller";
                payload.pickup_point_code = null;
                payload.pickup_store_name = "Pick up from seller";
                payload.delivery_amount = "0.00";
            }

            this.submit_confirmation_payload(payload);
        }
    });
},

        get_checkout_confirmation_payload() {
            const payload = {
                user_id: this.user_details.user_id,
                delivery_method: this.delivery_method,
                payment_type: this.selected_payment_type,
            };

            if (this.cart_item) {
                return ({
                    ...payload,
                    cart_item_id: this.cart_item,
                });
            }

            if (this.cart?.id) {
                return ({
                    ...payload,
                    cart_id: this.cart.id,
                });
            }

            return null;
        },

        submit_confirmation_payload(payload) {
            if (this.buy_now_checkout) {
                this.submit_buy_now_payload(payload);
                return;
            }
            this.submit_checkout_payload(payload);
        },
        get_cart_checkout_item() {
        return (
            this.cart_items?.[0] ||
            this.cart_items?.items?.[0] ||
            (this.cart_items?.product && this.cart_items)
        );
        },

        get_cart_item_attribute_ids(item) {
            const attributes = item?.attributes || [];
            if (!Array.isArray(attributes)) return [];
            return attributes
                .map((attribute) => {
                    return attribute?.product_attribute

                })
                .filter((attribute_id) => attribute_id !== null && attribute_id !== undefined && attribute_id !== "");
        },

        get_buy_now_payload(checkout_payload) {
            const item = this.get_cart_checkout_item();
            const product_id = item?.product?.id;
            if (!item || !product_id) return null;

            return ({
                ...checkout_payload,
                product_id,
                quantity: Number(item.quantity || 1),
                attributes: this.get_cart_item_attribute_ids(item),
            });
        },

        fetch_cart_order() {
            const order_id = this.order_id;
            const user_id = this.user_details.user_id;
            this.loading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_order/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify({
                    user_id: user_id,
                    order_id: order_id
                }),
                success: (response) => {

                    this.orders = response.order;
                    this.sync_selected_order_delivery();
                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;

                    console.error("Failed to fetch order:", xhr.responseText);
                },
            });
        },

        select_fulfillment_method(method) {
            this.delivery_method = method;

            if (method === "delivery") {
                this.delivery_amount = 0;
            }
        },

        update_delivery_address(address) {
            this.delivery_address = {
                ...this.delivery_address,
                ...(address || {}),
            };
            this.clear_delivery_address_errors(address || {});
        },

        get_user_address_url(endpoint) {
            return `${process.env.VUE_APP_BACKEND_API_URL}/company_management/${endpoint}/`;
        },

        get_new_delivery_address_payload(address = {}) {
            return ({
                contact_name: address.contact_name,
                email: address.email,
                contact_phone: address.contact_phone,
                street_address: address.street_address,
                suburb: address.suburb,
                city: address.city,
                province: address.province,
                postal_code: address.postal_code,
            });
        },

        clear_delivery_address_errors(address) {
            const fields = [
                "contact_name",
                "contact_phone",
                "email",
                "street_address",
                "suburb",
                "city",
                "province",
                "postal_code",
            ];

            this.delivery_address_errors = Object.fromEntries(
                fields.map((field) => [
                    field,
                    Reflect.get(address, field)
                        ? ""
                        : Reflect.get(this.delivery_address_errors, field),
                ])
            );
        },

        get_error_message(error, fallback = "Something went wrong. Please try again.") {
            return [
                error,
                Reflect.get(error ?? {}, "message"),
                Reflect.get(error ?? {}, "error")
            ].find(value => typeof value === "string") || fallback;
        },

        save_delivery_address_if_needed() {
            const address = this.get_delivery_address_payload();
            const address_id = address.address_id;
            if (address_id) {
                return Promise.resolve({
                    ...address,
                    address_id,
                });
            }

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: this.get_user_address_url("save_user_address"),
                    method: "POST",
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify({
                        user_id: this.user_details?.user_id,
                        ...this.get_new_delivery_address_payload(address),
                    }),
                    success: (response) => this.handle_saved_delivery_address_response(response, address, resolve, reject),
                    error: (xhr) => {
                        reject(new Error(this.get_error_message(xhr.responseJSON, "Could not save delivery address.")));
                    },
                });
            });
        },

        submit_checkout_payload(payload) {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/initiate_checkout/`,
                method: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),
                success: (response) => this.handle_checkout_response(response),
                error: (xhr) => {
                    this.confirming_order = false;

                    Swal.fire({
                        icon: 'error',
                        title: 'Server Error',
                        text: this.get_error_message(xhr.responseJSON),
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        },

        submit_buy_now_payload(checkout_payload) {
            const payload = this.get_buy_now_payload(checkout_payload);

            if (!payload) {
                this.confirming_order = false;
                this.show_checkout_error("Buy now checkout item not found.");
                return;
            }

            buy_now_order({
                token: this.getToken(),
                payload
            })
                .then((response) => this.handle_checkout_response(response))
                .catch((xhr) => {
                    this.confirming_order = false;
                    this.show_checkout_error(this.get_error_message(xhr.responseJSON));
                });
        },

        handle_saved_delivery_address_response(response, address, resolve, reject) {
            if (this.has_saved_delivery_address_error(response)) {
                return reject(new Error(this.get_error_message(response, "Could not save delivery address.")));
            }

            this.delivery_address = this.get_merged_saved_delivery_address(response, address);
            return resolve(this.get_delivery_address_payload());
        },

        has_saved_delivery_address_error(response) {
            return response?.status === "error" || response?.success === false;
        },

        get_merged_saved_delivery_address(response, address) {
            const saved_address = this.get_saved_address_from_response(response);

            return ({
                ...this.delivery_address,
                ...address,
                ...saved_address,
                address_id: this.get_saved_delivery_address_id(saved_address, address),
            });
        },

        get_saved_delivery_address_id(saved_address, address) {
            return saved_address.address_id || address.address_id || null;
        },

        get_saved_address_from_response(response) {
            if (Array.isArray(response?.data)) return response.data[0] || {};
            return response?.data;
        },

        handle_checkout_response(response) {
            this.confirming_order = false;

            if (response.status !== "success") {
                this.show_checkout_error(this.get_error_message(response, 'Failed to confirm order.'));
                return;
            }

            this.order = response.order;
            this.checkout_confirmed = true;
            Swal.fire({
                icon: 'success',
                title: 'Order Confirmed',
                text: 'Your order was sent to the seller for approval.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            }).then(() => {
                this.$router.push({ name: 'my_orders' });
            });
        },

        show_checkout_error(message) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            });
        },

        cleanup_abandoned_buy_now_item() {
            const cleanup_blockers = [
                !this.buy_now_checkout,
                this.checkout_confirmed,
                !this.cart_item,
                this.cleaning_buy_now_item,
            ];
            if (cleanup_blockers.some(Boolean)) return;

            this.cleaning_buy_now_item = true;
            delete_cart_item({
                cart_item_id: this.cart_item,
                token: this.getToken()
            }).catch((error) => {
                console.error("Failed to remove abandoned buy now item:", error);
            });
        },

        get_selected_order_delivery_address() {
            return this.orders?.order_delivery?.delivery_address || {};
        },

        sync_selected_order_delivery() {
            const delivery = this.orders?.order_delivery;

            if (!delivery) return;

            this.delivery_method = "delivery";
            this.delivery_address = this.get_selected_order_delivery_address();
            this.delivery_amount = this.get_order_delivery_amount(delivery);
        },

        get_order_delivery_amount(delivery) {
            const amount = [
                delivery.delivery_amount,
                delivery.amount,
                this.orders?.delivery_amount,
            ].map(Number).find(Boolean);

            return amount || 0;
        },

        get_delivery_address_payload() {
            return get_delivery_address_payload(this.delivery_address);
        },

        get_missing_delivery_address_fields(address) {
            return [
                ['contact_name', 'contact name', address.contact_name],
                ['contact_phone', 'contact number', address.contact_phone],
                ['street_address', 'street address', address.street_address],
                ['suburb', 'suburb / local area', address.suburb],
                ['city', 'city', address.city],
                ['province', 'province', address.province],
                ['postal_code', 'postal code', address.postal_code],
            ].filter(([, , value]) => !value);
        },

        get_missing_delivery_address_message(missing_fields) {
            return `Please add the following delivery details:\n${missing_fields.map(([, label]) => `- ${label}`).join('\n')}`;
        },

        get_delivery_address_errors(missing_fields) {
            return missing_fields.reduce((errors, [field, label]) => {
                Reflect.set(errors, field, `Please add ${label}.`);
                return errors;
            }, {});
        },

        validate_delivery_address() {
            const address = this.get_delivery_address_payload();
            const missing_fields = this.get_missing_delivery_address_fields(address);

            this.delivery_address_errors = this.get_delivery_address_errors(missing_fields);

            if (!missing_fields.length) {
                this.delivery_address_errors = {};
                return true;
            }

            Swal.fire({
                icon: 'warning',
                title: 'Missing Delivery Details',
                text: this.get_missing_delivery_address_message(missing_fields),
                position: 'bottom-end',
                toast: true,
                timer: 5000,
                showConfirmButton: false,
            });

            return false;
        },
        save_order_fulfillment({ url, payload }) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url,
                    method: "POST",
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify(payload),
                    success: (response) => {
                        if (response?.status === "error" || response?.success === false) {
                            reject(new Error(this.get_error_message(response, "Could not save delivery details.")));
                            return;
                        }

                        resolve(response);
                    },
                    error: (xhr) => {
                        reject(new Error(this.get_error_message(xhr.responseJSON, "Could not save delivery details.")));
                    },
                });
            });
        },

        proceed_to_payment() {
            const order_id = this.order_id;
            const user_id = this.user_details.user_id;
            const delivery_amount = Number(this.fulfillment_delivery_amount || 0).toFixed(2);

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_products_payment/`,
                method: 'POST',
                data: JSON.stringify({
                    user_id: user_id,
                    order_id: order_id,
                    payment_type_id: this.selected_payment_type,
                    pickup_type: this.delivery_method === "pickup" ? "seller" : null,
                    pickup_point_code: null,
                    pickup_store_name: this.delivery_method === "pickup" ? "Pick up from seller" : null,
                    delivery_amount: delivery_amount,
                    delivery_address: this.delivery_method === "delivery" ? this.get_delivery_address_payload() : null,
                    address_id: this.delivery_method === "delivery" ? this.get_delivery_address_payload().address_id : null,
                    delivery_address_id: this.delivery_method === "delivery" ? this.get_delivery_address_payload().address_id : null,
                    product_promo_code_id: this.get_applied_product_promo_id(),
                }),
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                success: (response) => {
                    if (response.success) {
                        var data_array = response.data_array;
                        const form = $('#payment_form');
                        for (var [key, value] of Object.entries(data_array)) {
                            var input = $('#input_clone').clone();
                            input.attr('name', key);
                            input.attr('value', value);  // Accessing value without square brackets
                            input.removeAttr('id');
                            input.removeClass('d-none');
                            form.append(input);
                        }

                        Swal.fire({
                            title: 'Success',
                            icon: 'success',
                            text: "Redirecting to PayFast in a few seconds don't close this page",
                            showConfirmButton: false,
                            position: 'bottom-end',
                            timer: 3000,
                            toast: true
                        });

                        form.submit();
                        return;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Payment Error',
                        text: this.get_error_message(response, 'Payment could not be created. Please try again later.'),
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                },
                error: (xhr) => {
                    console.error('Failed to create products payment:', xhr.responseText);
                    Swal.fire({
                        icon: 'error',
                        title: 'Payment Error',
                        text: this.get_error_message(xhr.responseJSON, 'Payment failed. Please try again later.'),
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        },
    get_product_promo_name(promo = {}) {
        return promo?.promo_code || "";
    },

    get_product_promo_product_id(promo = this.applied_product_promo) {
        return this.get_product_promo_product_ids(promo)[0] || null;
    },

    get_product_promo_product_ids(promo = this.applied_product_promo) {
        return [
            ...new Set(
                [
                    promo?.product?.id,
                    promo?.product_id,
                    ...(promo?.product_ids || []),
                ]
                    .filter(Boolean)
                    .map(String)
            ),
        ];
    },

    get_order_item_product_id(item) {
        return item?.product?.id || item?.product_id || null;
    },

    get_product_promo_codes_from_item(item) {
        return item?.product?.promo_codes || item?.promo_codes || [];
    },

    is_product_promo_attached_to_item(item) {
        const promo_id = this.get_applied_product_promo_id();
        const promo_name = this.get_product_promo_name(this.applied_product_promo);

        return this.get_product_promo_codes_from_item(item).some(
            (promo_code) =>
                String(promo_code?.id) === String(promo_id) ||
                String(promo_code?.promo_code || "").toLowerCase() ===
                    String(promo_name).toLowerCase()
        );
    },

    is_product_promo_applied_to_item(item) {
        const product_ids = this.get_product_promo_product_ids();
        const product_id = this.get_order_item_product_id(item);

        return (
            product_ids.includes(String(product_id)) ||
            this.is_product_promo_attached_to_item(item)
        );
    },

    get_applied_product_promo_item() {
        return this.orders?.products?.find(
            (item) => this.is_product_promo_applied_to_item(item)
        ) || null;
    },

    get_applied_product_promo_id() {
        return this.applied_product_promo?.id || null;
    },

    get_order_product_ids() {
        return (this.orders?.products || [])
            .map((item) => this.get_order_item_product_id(item))
            .filter(Boolean);
    },
        apply_product_promo() {
            const promo_code_name = String(this.product_promo_input || "").trim();
            const product_ids = this.get_order_product_ids();

            if (!promo_code_name || !product_ids.length || !this.order_id || !this.order_id) return;

            this.is_applying_product_promo = true;
            this.product_promo_message = "";
            this.product_promo_status = "";

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/validate_product_promo_code/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    user_id:this.user_details.user_id,
                    order_id: this.order_id,
                    product_ids,
                    promo_code_name,
                }),
                success: (response) => {
                    if (response.status === "success") {
                        const applied_promo = response.data || null;
                        const discount_amount = this.get_payment_promo_discount_amount(applied_promo);
                        this.applied_product_promo = applied_promo;
                        this.product_promo_status = "success";
                        this.product_promo_message = response.message || (
                            discount_amount > 0
                                ? `Promo will discount ${this.format_currency(discount_amount)} when you pay.`
                                : "Promo code will be applied when you pay."
                        );
                    } else {
                        this.applied_product_promo = null;
                        this.product_promo_status = "error";
                        this.product_promo_message = response.message || "Invalid promo code.";
                    }
                },
                error: (xhr) => {
                    this.applied_product_promo = null;
                    this.product_promo_status = "error";
                    this.product_promo_message = xhr?.responseJSON?.message || "Invalid promo code for this order.";
                },
                complete: () => {
                    this.is_applying_product_promo = false;
                },
            });
        },

        fetch_cart_item() {
            const user_id = this.user_details.user_id;
            this.loading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart_item/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    user_id: user_id,
                    cart_item_id: this.cart_item
                }),
                success: (response) => {
                    if (response.status === "success") {
                        this.cart_items = response.data.item;   // 🔥 normalized cart structure
                    } else {
                        this.cart_items = { items: [] };
                        console.error("Failed to load cart item:", response.message);
                    }

                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;
                    console.error("Failed to fetch cart item:", xhr.responseText);

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Failed to load item for checkout",
                        toast: true,
                        timer: 1500,
                        position: "bottom-end",
                        showConfirmButton: false
                    });
                }
            });
        }
    }
}
